export enum BannerGridOrientation {
  IMG_LEFT = "image-left",
  IMG_RIGHT = "image-right",
}

export enum BannerGridColorSchemes {
  LIGHT_BACKGROUND_PRIMARY_TITLE = "light-background-primary-title",
  LIGHT_BACKGROUND_DARK_TITLE = "light-background-dark-title",
  PRIMARY_BACKGROUND = "primary-background",
}

export enum BannerGridImageFitTypes {
  COVER = "cover",
  CONTAIN_BG_WHITE = "contain-bg-white",
  CONTAIN_BG_PRIMARY = "contain-bg-primary",
  CONTAIN_BG_TRANSPARENT = "contain-bg-transparent",
}
